export default "__VITE_ASSET__c5d9f98e__"